/* eslint-disable no-unused-vars */

import { colors } from 'assets/jss/colors'
import { createTheme } from '@material-ui/core/styles'

const defaultTheme = createTheme()

const editTableStyle = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: defaultTheme.spacing(1),
    color: colors.successColor[0]
  },
  textPrimary: {
    color: colors.primaryColor[0]
  }
}

export default editTableStyle
